import { isFinFitPartnership, partnerSvgLogoMap } from '@/utils/partnership';
import { Flex, Image, Text } from '@mantine/core';

interface Props {
  partnership: string;
  logoSrc?: string;
}

export const PartnerAttribution = ({ partnership, logoSrc }: Props) => {
  const isSvg = isFinFitPartnership(partnership);
  const SvgComponent = partnerSvgLogoMap.get(partnership);

  return (
    <Flex
      align="flex-end"
      gap={10}
    >
      <Text
        size={12}
        c="white"
      >
        Included with
      </Text>
      {isSvg && SvgComponent ? (
        <SvgComponent
          width={100}
          height={28}
          color="white"
        />
      ) : (
        logoSrc && (
          <Image
            src={logoSrc}
            width={120}
            alt={`${partnership} logo`}
          />
        )
      )}
    </Flex>
  );
};
